import Hecate from '@bybit/hecate';

/**
 * APP 登录或者获取 token 的通用方法
 *
 * @param {boolean} needLogin 是否需要登录
 * @return {promise<string>}
 */
const userProfile = (needLogin) => Hecate
    .module('UserProfile')
    .method('getUserProfile')
    .invoke({ needLogin })
    .then((res) => res.params.userToken || '');

/**
 * 跳转 APP 页面的通用方法
 *
 * @param {Object} params APP模块参数
 * @param {string} params.path APP模块名称
 * @return {promise}
 */
export const jumpAppPage = (params) => Hecate
    .module('Router')
    .method('push')
    .invoke(params);

/**
 * 跳转 APP 登录页
 *
 * @return {promise<string>}
 */
export const jumpLogin = () => userProfile(true);

/**
 * 获取 APP token
 *
 * @return {promise<string>}}
 */
export const getUserToken = () => userProfile(false);

/**
 * 跳转 APP KYC 页面
 *
 * @return {promise}
 */
export const jumpKYC = () => jumpAppPage({ path: 'KycHomePage' });

/**
 * 跳转 APP 充值页面
 *
 * @param {string} coin 币种
 * @return {promise}
 */
export const jumpRecharge = (coin = 'BTC') => jumpAppPage({ path: 'finance-invest-home', coin });

/**
 * 跳转到交易页
 *
 * @param {string} base 基础货币
 * @param {string} quote 计价货币
 * @return {promise}
 */
export const jumpTrade = (base, quote) => jumpAppPage({
    path: `bybitapp://open/home?tab=3&symbol=${base.toLocaleUpperCase()}${quote.toLocaleUpperCase()}`,
});

/**
 * 获取 App 版本号
 *
 * @return {promise<string>}
 */
export const getAppVersion = () => Hecate
    .module('SystemInfo')
    .method('getAppConfig')
    .invoke({})
    .then((res) => res.params.appVersion.toString());

/**
 * 使用浏览器打开链接
 *
 * @param {string} url 跳转链接
 * @return {promise}
 */
export const openBrowser = (url) => Hecate
    .module('UrlLauncher')
    .method('open')
    .invoke({ url });

/**
 * 调起 APP 的分享组件。支持两种形式：图片(base64)、文本(支持写入链接)
 *
 * @param {Object} shareInfo 分享信息对象
 * @param {string} [shareInfo.type] 分享的类型：image 是图片， 默认是文本
 * @param {base64} shareInfo.data 分享的图片内容，格式为base64
 * @param {string} shareInfo.text 分享的文本内容，可以写入链接
 * @return {promise}
 */
export const share = (shareInfo) => {
    if (shareInfo.type === 'image') {
        return Hecate
            .module('Share')
            .method('shareImage')
            .invoke({ data: shareInfo.data.replace(/^data:image\/\w+;base64,/, '') });
    }
    return Hecate
        .module('Share')
        .method('shareText')
        .invoke({ text: shareInfo.text });
};

/**
 * 跳转到 VIP 页面
 */
export const jumpVip = () => jumpAppPage({ path: 'bybitapp://open/vip' });

/**
 * 跳转到现货订单页面
 *
 * @param {string} tabKey tab 页
 * @param {string} symbolId 交易对
 * @return {undefined}
 */
export const jumpSpotOrder = (tabKey, symbolId = '') => jumpAppPage({
    path: `bybitapp://open/spot_all_orders?tabKey=${tabKey}&symbolId=${symbolId}`,
});
